<app-modal
  title="Create Taxonomy"
  subtitle="Define a new master classification for use across multiple taxonomies."
  (closed)="closed.emit()"
>
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Taxonomy Name</label>
    <input
      type="text"
      placeholder="Type name..."
      [value]="taxonomyName()"
      (input)="taxonomyName.set($any($event.target).value)"
      [class.border-red-400]="showErrors() && !taxonomyName().trim()"
      [class.ring-2]="showErrors() && !taxonomyName().trim()"
      [class.ring-red-100]="showErrors() && !taxonomyName().trim()"
      class="w-full"
    />
    @if (showErrors() && !taxonomyName().trim()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Classification Type</label>
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-1 gap-1">
      <button
        type="button"
        (click)="classificationType.set('Situation')"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          classificationType() === 'Situation'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-slate-500 hover:text-navy-700'
        "
      >
        Situation Category
      </button>
      <button
        type="button"
        (click)="classificationType.set('Response')"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          classificationType() === 'Response'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-slate-500 hover:text-navy-700'
        "
      >
        Response Category
      </button>
    </div>
  </div>

  <div class="flex flex-col gap-1.5 mb-2">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Election Type</label>
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-1 gap-1">
      <button
        type="button"
        (click)="isMultiItem.set(true)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          isMultiItem() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Multiple Choice
      </button>
      <button
        type="button"
        (click)="isMultiItem.set(false)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          !isMultiItem() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Single Choice
      </button>
    </div>
  </div>

  <div modal-footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="closed.emit()"
      class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      [disabled]="submitting()"
      class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {{ submitting() ? 'Creating...' : 'Create Taxonomy' }}
    </button>
  </div>
</app-modal>
